import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable()
export class FormElementsService {

  constructor(private http: HttpClient) {
  }

  public getOptionList(id: string, text: string, context?: string): Promise<any> {
    let params = new HttpParams();
    params = params.set('field', id);
    params = params.append('text', text);
    if (context) {
      params = params.append('context', context);
    }
    return this.http.get(`${environment.api_url}/auto_complete`, {params})
      .pipe(
        map((res: any) => {
          return res;
        })
      ).toPromise();
  }

  public getStudyFieldNameToUrl(studyFieldName: string): string {
    return studyFieldName.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ /g, '-').replace(/ /g, '-');
  }
}
